import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { PencilIcon } from "@heroicons/react/outline";

export default class EditableTitle extends React.Component
{
    state = {
        editing: false,
        value: this.props.value,
        original: this.props.value,
    };

    static propTypes = {
        value: PropTypes.string.isRequired,

        onBlur: PropTypes.func,
    };

    static defaultProps = {
        onBlur: () => {}
    };

    onClick = () => {
        if (this.state.editing) {
            return;
        }

        this.setState({ editing: true, original: this.state.value }, () => {
            this.input.select();
            this.resize();
        });
    };

    onBlur = () => {
        this.setState({ editing: false, width: 0 });

        this.save();
    };

    onChange = event => {
        this.setState({ value: event.target.value });
        this.resize();
    };

    onKeyDown = event => {
        switch(event.keyCode) {
            case 13: // Enter
                this.setState({ editing: false });
                this.save();
                break;
            case 27: // Esc
                this.setState({ editing: false, value: this.state.original });
                break;
        }
    };

    save = () => {
        if (this.state.value === this.state.original) {
            return;
        }

        this.props.onBlur(this.state.value);
    };

    resize = () => {
        this.setState({
            width: this.input.scrollWidth
        });
    };

    render()
    {
        const inputWrapperClasses = classNames({
            "py-1 px-2 rounded flex-1": true,
            "group-hover:bg-gray-100": ! this.state.editing,
            "bg-gray-200 border": this.state.editing,
        });

        const pencilClasses = classNames({
            "group-hover:visible ml-2 text-gray-500 flex-shrink-0 w-4": true,
            "invisible": ! this.state.editing,
        });

        return <div className='group flex items-center cursor-pointer' onClick={this.onClick} onBlur={this.onBlur}>
            <div className={inputWrapperClasses}>
                {
                    this.state.editing
                        ? this.renderEditableValue(this.state.value)
                        : this.state.value
                }
            </div>
            <PencilIcon className={pencilClasses} />
        </div>;
    }

    renderEditableValue(value)
    {
        return <input
            value={value}
            ref={ref => this.input = ref}
            className="bg-transparent outline-none border-0"
            onChange={this.onChange}
            onKeyDown={this.onKeyDown}
            style={{
                width: this.state.width
            }}
        />;
    }
}
